export default __webpack_public_path__ + "static/sr-523ebd93705619360572cede74a5828b.svg";